webpackJsonp([14],{

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__(377);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1330173a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__(470);
function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1330173a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_GroupService__ = __webpack_require__(469);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {
      //Visual
      loading: false,
      ////////
      title: "Listagem de Grupo",
      footerText: "Total de registos: ",
      loadingRecordsText: "Carregando registros...",
      emptyRecordsText: "Nenhum registro encontrado",
      dialog: false,
      dialogRemove: false,
      confirmedExclusion: false,
      isEditing: false,
      records: 0,
      groupRemove: {},
      groupEdit: {},
      groups: [],
      group: {},
      imageName: '',
      imageUrl: '',
      imageFile: '',
      headers: [{
        text: 'Descrição',
        align: "center",
        value: 'description'
      }, {
        text: 'Ações',
        align: 'center',
        value: 'description',
        sortable: false
      }]
    };
  },

  computed: {
    formTitle: function formTitle() {
      return this.isEditing ? 'Editar Grupo' : 'Criar Grupo';
    },
    dynamicFooterText: function dynamicFooterText() {
      var text = "" + (this.loading ? this.loadingRecordsText : this.emptyRecordsText);
      return text;
    }
  },

  watch: {
    dialog: function dialog(val) {
      val || this.initialize();
    }
  },

  created: function created() {
    this.initialize();
  },


  methods: {
    calculateRecords: function calculateRecords() {
      var amount = 0;
      this.groups.forEach(function (element) {
        amount++;
      });
      this.records = amount;
    },
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__service_GroupService__["a" /* default */].getAll();

              case 4:
                _this.groups = _context.sent;

                _this.calculateRecords();
                _this.isEditing = false;
                _this.dialog = false;
                _this.dialogRemove = false;
                _this.group = {};
                _this.groupEdit = {};
                _this.groupRemove = {};
                _this.confirmedExclusion = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 18:
                _context.prev = 18;

                _this.loading = false;
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 15, 18, 21]]);
      }))();
    },
    edit: function edit(groupEditing) {
      this.groupEdit = groupEditing;
      this.isEditing = true;
      this.disabledButtonSave = false;
      this.dialog = true;
    },
    remove: function remove() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__service_GroupService__["a" /* default */].remove(_this2.groupRemove);

              case 2:
                _this2.initialize();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _this3.group = _this3.groupEdit;
                _context3.prev = 2;

                if (!_this3.isEditing) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2__service_GroupService__["a" /* default */].update(_this3.group);

              case 6:
                _context3.next = 10;
                break;

              case 8:
                _context3.next = 10;
                return __WEBPACK_IMPORTED_MODULE_2__service_GroupService__["a" /* default */].save(_this3.group);

              case 10:
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](2);

                console.log(_context3.t0);

              case 15:
                _context3.prev = 15;

                _this3.loading = false;
                _this3.initialize();
                _this3.clear();
                return _context3.finish(15);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 12, 15, 20]]);
      }))();
    },
    // save()

    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this4 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          _this4.imageUrl = fr.result;
          _this4.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
      }
    },
    clear: function clear() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.group = {};

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  }
});

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(468);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("6ebd35ec", content, true, {});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Group.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);









var url = __WEBPACK_IMPORTED_MODULE_4__configuration__["a" /* default */].apiHost;

var GroupService = function () {
  function GroupService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GroupService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GroupService, null, [{
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var groups;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url + "groups");

              case 3:
                groups = _context.sent;
                return _context.abrupt('return', groups.data.result);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                throw _context.t0.response.data;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'save',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(group) {
        var groupSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url + "groups", group);

              case 3:
                groupSaved = _context2.sent;
                return _context2.abrupt('return', groupSaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(group) {
        var groupUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url + "groups", group);

              case 3:
                groupUpdated = _context3.sent;
                return _context3.abrupt('return', groupUpdated.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(group) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(url + "groups", {
                  data: group
                });

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref4.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return GroupService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (GroupService);

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"headline font-weight-light"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","loading":_vm.loading,"disabled":_vm.loading,"color":"info","icon":"","round":"","title":"Inserir um novo registro"},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-card',[_c('v-toolbar',{staticClass:"elevation-3",attrs:{"color":"white"}},[_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","icon":"","round":"","flat":""},on:{"click":function($event){return _vm.initialize();}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("remove")])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"headline font-weight-light"},[_vm._v(_vm._s(_vm.formTitle))])],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Descrição"},model:{value:(_vm.groupEdit.description),callback:function ($$v) {_vm.$set(_vm.groupEdit, "description", $$v)},expression:"groupEdit.description"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center",attrs:{"xs12":""}},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"height":"150"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Select Image","prepend-icon":"attach_file"},on:{"click":_vm.pickFile},model:{value:(_vm.imageName),callback:function ($$v) {_vm.imageName=$$v},expression:"imageName"}}),_vm._v(" "),_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","block":"","round":""},on:{"click":function($event){return _vm.save();}}},[_vm._v("Salvar")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"rows-per-page-text":"Colunas por página","loading":_vm.loading,"headers":_vm.headers,"items":_vm.groups},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0 text-xs-center"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"title":"Editar registro","color":"info","round":"","flat":"","icon":""},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"info"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"title":"Excluir registro","color":"error","round":"","flat":"","icon":""},on:{"click":function($event){_vm.groupRemove = props.item; _vm.dialogRemove = true;}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n      Linhas "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),(_vm.records > 0)?_c('template',{slot:"footer"},[_c('td',{attrs:{"colspan":"100%"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.footerText)+" "+_vm._s(_vm.records)+" ")])])]):_c('template',{slot:"no-data"},[_c('strong',[_vm._v(" "+_vm._s(_vm.emptyRecordsText)+" ")])])],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogRemove),callback:function ($$v) {_vm.dialogRemove=$$v},expression:"dialogRemove"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-3",attrs:{"color":"white","card":""}},[_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","flat":"","round":"","icon":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("remove")])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"headline font-weight-light"},[_vm._v("Excluir Registro")])],1),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v("Descrição: "+_vm._s(_vm.groupRemove.description))])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"font-weight-light",attrs:{"color":"success lighten-1","round":"","block":""},on:{"click":function($event){return _vm.remove();}}},[_vm._v("\n            Sim\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.af77a5a98ef84d3be58d.js